import React from "react";
import "./stepper.scss";
import { TickWithGreenBgIcon } from "../../SVG/tick-with-green-bg";
import { DashedVerticalLineIcon } from "../../SVG/dashed-vertical-line";

export interface StepperProps {
  id: number;
  currentActiveIndex?: number;
  label: string;
  stepperText: string;
  showDashedLine?: boolean;
  stepperContent?: React.ComponentType<any>;
}

export function Stepper(props: StepperProps) {
  const {
    id,
    currentActiveIndex,
    label,
    stepperText,
    showDashedLine = true,
  } = props;

  if (id < (currentActiveIndex || 0)) {
    return (
      <>
        <div className="stepper-container completed">
          <div className="stepper-number-container">
            <div className="stepper-number">
              <TickWithGreenBgIcon />
            </div>
          </div>
          <div className="stepper-text">{label}</div>
        </div>
        {showDashedLine && (
          <div className="stepper-dashed-line">
            <DashedVerticalLineIcon />
          </div>
        )}
      </>
    );
  } else if (id === currentActiveIndex) {
    return (
      <>
        <div className="stepper-container active">
          <div className="stepper-number-container">
            <div className="stepper-number">{stepperText}</div>
          </div>
          <div className="stepper-text">{label}</div>
        </div>
        {showDashedLine && (
          <div className="stepper-dashed-line">
            <DashedVerticalLineIcon />
          </div>
        )}
      </>
    );
  } else {
    return (
      <>
        <div className="stepper-container">
          <div className="stepper-number-container">
            <div className="stepper-number">{stepperText}</div>
          </div>
          <div className="stepper-text">{label}</div>
        </div>
        {showDashedLine && (
          <div className="stepper-dashed-line">
            <DashedVerticalLineIcon />
          </div>
        )}
      </>
    );
  }
}
